import {Dog} from "./dog";
import {User} from "./user";
import {Service} from "./service";

export class ServiceLog {
    id: string;
    start: Date;
    end: Date;
    notes: string;
    initiative: string
    serviceId: string;
    service: Service;
    dogId: string;
    dog: Dog;
    userId: string;
    user: User;
}



// WEBPACK FOOTER //
// ./src/classes/serviceLog.ts